<template>
  <div class="car-tile card col-md-4 m-2 text-center" :class="{ 'card-primary': isSelected, 'card-default': !isSelected }" @click="$emit('carChanged', car)">
    <span class="tick" v-if="isSelected">
      <i class="fa text-light fa-lg fa-check-circle"></i>
    </span>
    <div :class="{ 'card-header border-primary': isSelected, 'card-header': !isSelected }">
      <p><strong class="car-name">{{ car.CarType.name }}</strong></p>
      <span v-if="isCurrent" class="current">Current Car</span>
      <span v-else-if="isSelected" class="current">New Car</span>
      <span v-if="(!isSelected && !isCurrent) && (!car.oneWayTrips || !lotInformation.oneWayTrips || car.Reservations.length > 0 || car.LotRelocations.length > 0)" class="red current"> No One Way</span>
    </div>
    <div class="card-body">
      <div class="address">
        <i class="fa fa-map-marker-alt"></i> {{ lotInformation.address }}
      </div>
      <div class="features">
        <p><strong>Features</strong></p>
        <p>
          <template v-for="feature in car.CarFeatures">
            <span v-if="feature.icon" class="fa-lg" :class="[
                feature.icon,
                {
                  'fab': feature.icon === 'fa-bluetooth',
                  'fa': feature.icon !== 'fa-bluetooth'
                }
              ]" :title="feature.name"></span>&nbsp;
          </template>
          <template v-if="!car.CarFeatures.length">&nbsp;</template>
        </p>
      </div>
      <p><img class="img-thumbnail" :src="carImage"/></p>
      <p>#{{car.convadisId}} - {{car.name}}</p>
      <label class="badge" :class="randomLabel(car.CarType.CarClass.name)">{{ car.CarType.CarClass.name }}</label></br>
      <label class="badge" :class="carStatus(car.uuid).className">{{ carStatus(car.uuid).label }}</label>
      <p class="label-distance">
        <i class="fa fa-location-arrow fa-lg"></i> Approx. {{ distance }} away
      </p>
    </div>
  </div>
</template>

<script>
import { randomLabel } from '@/util/helpers'
export default {
  name: 'CarTile',
  props: {
    car: {
      type: Object
    },
    selected: {
      type: String
    },
    oneWay: {
      type: Boolean
    },
    current: {
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {
    carImage () {
      return `https://techcar-dev.s3.amazonaws.com/${this.car.CarType.AmazonImage.objectKey}`
    },
    isSelected () {
      return this.car.uuid === this.selected
    },
    isCurrent () {
      return this.car.uuid === this.current
    },
    distance () {
      if (this.car.distance > 1000) {
        return (this.car.distance / 1000).toFixed(2) + 'km'
      } else {
        return this.car.distance.toFixed(0) + 'm'
      }
    },
    lotInformation () {
      // default lot
      let lot = this.car.Lot
      let relocationEndTime = false
      // loop through pending relocations
      for (let relocation in this.car.LotRelocations) {
        // if the relocation is permanent
        if (relocation.permanent) {
          // if the booking is after the relocation
          if (moment(relocation.endDate).isBefore(this.start)) {
            // if there is a previously found relocation and its before the
            // found relocation OR if there is no previously found relocation
            if ((relocationEndTime && moment(relocationEndTime).isBefore(relocation.endDate)) || !relocationEndTime) {
              lot = relocation.Lot
              relocationEndTime = relocation.endDate
            }
          }
        } else {
          // temporary relocations
          // if the booking times are between the relocation
          if (moment(this.start).isBetween(relocation.startDate, relocation.endDate) &&
            moment(this.end).isBetween(relocation.startDate, relocation.endDate)) {
            lot = relocation.Lot
          }
        }
      }
      return lot
    }
  },
  mounted () {
  },
  methods: {
    carStatus (uuid) {
      let label = 'Unavailable'
      let className = 'label-info'
      if (this.current !== uuid) {
        label = 'Available'
        className = 'label-success'
      } else if (this.current === uuid) {
        label = 'Current'
        className = 'label-primary'
      }
      return {
        className,
        label
      }
    },
    randomLabel
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/CarTile.vue